/** The flag is displayed immediately; each tile decides access by seat state. */
export const isShutdownPending = (table: any): boolean =>
  Number(table?.closing_after_hand ?? 0) === 1;
